import { render, staticRenderFns } from "./OrganizationDetails.vue?vue&type=template&id=253d71b2"
import script from "./OrganizationDetails.vue?vue&type=script&lang=js"
export * from "./OrganizationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports